export default "__VITE_ASSET__j$E2gDwR__"